import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-14e44a5f")

_pushScopeId("data-v-14e44a5f")
const _hoisted_1 = { class: "committee" }
const _hoisted_2 = {
  class: "file-window",
  id: "fullscreenView"
}
const _hoisted_3 = { class: "div-title" }
const _hoisted_4 = {
  key: 0,
  class: "file-name"
}
const _hoisted_5 = {
  class: "mr-1",
  style: {"float":"right","display":"inline","z-index":"999"}
}
const _hoisted_6 = { class: "iframe" }
const _hoisted_7 = { class: "right-side" }
const _hoisted_8 = { class: "div-title" }
const _hoisted_9 = { class: "tabs" }
const _hoisted_10 = { class: "meeting-note" }
const _hoisted_11 = { class: "note-pad" }
const _hoisted_12 = {
  key: 0,
  class: "once-off-note"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "Tip: "),
  /*#__PURE__*/_createTextVNode(" Notes are deleted after the meeting is concluded.")
], -1)
const _hoisted_14 = { class: "row button-row" }
const _hoisted_15 = {
  key: 0,
  class: "file-list"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("h4", null, "Agenda", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = { style: {"max-height":"200px","overflow":"auto"} }
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fal fa-file-pdf" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "del-btn" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("h4", null, "Agenda supporting", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_24 = { style: {"max-height":"200px","overflow":"auto"} }
const _hoisted_25 = /*#__PURE__*/_createVNode("i", { class: "fal fa-file-pdf" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "del-btn" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("h4", null, "Personal meeting files", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_30 = { style: {"max-height":"200px","overflow":"auto"} }
const _hoisted_31 = /*#__PURE__*/_createVNode("i", { class: "fal fa-file-pdf" }, null, -1)
const _hoisted_32 = { class: "del-btn" }
const _hoisted_33 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("h4", null, "Upload personal meeting files (PDF file only)", -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("small", null, "Maximum file size: 20MB", -1)
const _hoisted_38 = {
  key: 1,
  class: "meeting-details"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("h2", null, "Meeting details", -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("h4", null, "Method:", -1)
const _hoisted_42 = { key: 0 }
const _hoisted_43 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("h4", null, "Meeting Date:", -1)
const _hoisted_45 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("h4", null, "Meeting Note:", -1)
const _hoisted_47 = {
  class: "ql-container ql-snow",
  style: {"height":"calc(100vh - 500px)","width":"100%"}
}
const _hoisted_48 = /*#__PURE__*/_createVNode("h4", null, "Delete personal meeting file", -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("small", null, " Are you sure? ", -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("h4", null, "Your notes", -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("small", null, " You have some unsaved notes. In order to continue please tell us how you want to proceed. ", -1)
const _hoisted_52 = { class: "ls-slate" }
const _hoisted_53 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("br", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  const _component_QuillEditor = _resolveComponent("QuillEditor")
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_FileDragAndDrop = _resolveComponent("FileDragAndDrop")
  const _component_AlertBox = _resolveComponent("AlertBox")
  const _component_HelpScreen = _resolveComponent("HelpScreen")
  const _component_FullScreenFileViewer = _resolveComponent("FullScreenFileViewer")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.currentFile && _ctx.currentCommittee)
          ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.currentCommittee.name) + " | " + _toDisplayString(_ctx.currentFile.name), 1))
          : _createCommentVNode("", true),
        _createVNode("span", _hoisted_5, [
          _createVNode("i", {
            class: "fal fa-arrows-alt",
            "aria-hidden": "true",
            title: "Enter Fullscreen",
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.openFullscreen(_ctx.currentFile))),
            style: {"transform":"rotate(45deg)","font-size":"1.5em","cursor":"pointer"}
          })
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("iframe", {
          id: "refDocViewer",
          ref: "refDocViewer",
          class: "vue-doc-viewer",
          src: _ctx.fileSource,
          title: "iframe"
        }, "\n      ", 8, ["src"])
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("ul", _hoisted_9, [
          _createVNode("li", {
            class: _ctx.activeTab == 1 ? 'active': '' ,
            onClick: _cache[2] || (_cache[2] = $event => (_ctx.tapClicked(1)))
          }, "Personal meeting notes", 2),
          _createVNode("li", {
            class: _ctx.activeTab == 2 ? 'active': '' ,
            onClick: _cache[3] || (_cache[3] = $event => (_ctx.tapClicked(2)))
          }, "Files", 2),
          _createVNode("li", {
            class: _ctx.activeTab == 3 ? 'active': '' ,
            onClick: _cache[4] || (_cache[4] = $event => (_ctx.tapClicked(3)))
          }, "Meeting details", 2)
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _withDirectives(_createVNode("div", _hoisted_11, [
          (_ctx.showNote)
            ? (_openBlock(), _createBlock("div", _hoisted_12, [
                _hoisted_13,
                _createVNode("i", {
                  class: "fal fa-times-circle close-icon",
                  title: "Don't show this again",
                  onClick: _cache[5] || (_cache[5] = $event => {_ctx.setCookie('noted', 'noted', 365); _ctx.showNote = false;})
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", {
            class: ["wysiwygEditor", _ctx.showNote ? '' : 'more-height']
          }, [
            (_ctx.showEditor)
              ? (_openBlock(), _createBlock(_component_QuillEditor, {
                  key: 0,
                  ref: "quillEditor",
                  style: {"height":"calc(100vh - 390px)","width":"100%"},
                  theme: "snow",
                  onTextChange: _ctx.checkNote,
                  toolbar: _ctx.toolbarOptions,
                  content: _ctx.editorContent,
                  "onUpdate:content": _cache[6] || (_cache[6] = $event => (_ctx.editorContent = $event)),
                  contentType: "html"
                }, null, 8, ["onTextChange", "toolbar", "content"]))
              : _createCommentVNode("", true),
            (!_ctx.showEditor)
              ? (_openBlock(), _createBlock(_component_LoadingIndicator, { key: 1 }))
              : _createCommentVNode("", true)
          ], 2),
          _createVNode("div", _hoisted_14, [
            _createVNode("button", {
              class: "btn btn-tertiary sml mr-3",
              onClick: _cache[7] || (_cache[7] = $event => (_ctx.saveNote(false)))
            }, "Clear notes"),
            _createVNode("button", {
              class: "btn btn-primary sml",
              onClick: _cache[8] || (_cache[8] = $event => (_ctx.saveNote(true))),
              style: {"margin-right":"1em"}
            }, "Save")
          ])
        ], 512), [
          [_vShow, _ctx.activeTab == 1]
        ]),
        (_ctx.activeTab == 2)
          ? (_openBlock(), _createBlock("div", _hoisted_15, [
              _hoisted_16,
              _hoisted_17,
              _createVNode("ul", _hoisted_18, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.agendaFiles, (f, index) => {
                  return (_openBlock(), _createBlock("li", {
                    class: ["file-name", _ctx.fileId == f.id ? 'current' : ''],
                    onClick: $event => (_ctx.openFile(f))
                  }, [
                    _createVNode("div", {
                      title: f.name
                    }, [
                      _createVNode("p", null, [
                        _hoisted_19,
                        _createTextVNode(_toDisplayString(f.name), 1)
                      ])
                    ], 8, ["title"]),
                    _hoisted_20
                  ], 10, ["onClick"]))
                }), 256))
              ]),
              _hoisted_21,
              _hoisted_22,
              _hoisted_23,
              _createVNode("ul", _hoisted_24, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.agendaSupportingFiles, (f, index) => {
                  return (_openBlock(), _createBlock("li", {
                    class: ["file-name", _ctx.fileId == f.id ? 'current' : ''],
                    onClick: $event => (_ctx.openFile(f))
                  }, [
                    _createVNode("div", {
                      title: f.name
                    }, [
                      _createVNode("p", null, [
                        _hoisted_25,
                        _createTextVNode(_toDisplayString(f.name), 1)
                      ])
                    ], 8, ["title"]),
                    _hoisted_26
                  ], 10, ["onClick"]))
                }), 256))
              ]),
              _hoisted_27,
              _hoisted_28,
              _hoisted_29,
              _createVNode("ul", _hoisted_30, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.personalMeetingFiles, (f, index) => {
                  return (_openBlock(), _createBlock("li", {
                    class: ["file-name", _ctx.fileId == f.id ? 'current' : '']
                  }, [
                    _createVNode("div", {
                      onClick: $event => (_ctx.openFile(f)),
                      title: f.name
                    }, [
                      _createVNode("p", null, [
                        _hoisted_31,
                        _createTextVNode(_toDisplayString(f.name), 1)
                      ])
                    ], 8, ["onClick", "title"]),
                    _createVNode("div", _hoisted_32, [
                      _createVNode("button", {
                        class: "btn btn-tertiary sml",
                        onClick: $event => (_ctx.showFileDeleteAlert(f.id))
                      }, "Delete", 8, ["onClick"])
                    ])
                  ], 2))
                }), 256))
              ]),
              _hoisted_33,
              _hoisted_34,
              _hoisted_35,
              _hoisted_36,
              _createVNode(_component_FileDragAndDrop, {
                disabled: _ctx.isSubmitting,
                uploading: _ctx.isSubmitting,
                onFileInputChanged: _ctx.uploadAllPersonalMeetingFiles
              }, null, 8, ["disabled", "uploading", "onFileInputChanged"]),
              _hoisted_37
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeTab == 3)
          ? (_openBlock(), _createBlock("div", _hoisted_38, [
              _hoisted_39,
              _hoisted_40,
              _hoisted_41,
              _createVNode("p", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentCommittee.meeting.meetingTypes, (t, idx) => {
                  return (_openBlock(), _createBlock("span", null, [
                    (idx > 0)
                      ? (_openBlock(), _createBlock("span", _hoisted_42, ", "))
                      : _createCommentVNode("", true),
                    _createTextVNode(_toDisplayString(t.name), 1)
                  ]))
                }), 256))
              ]),
              _hoisted_43,
              _hoisted_44,
              _createVNode("p", null, _toDisplayString(_ctx.meetingDateTime(_ctx.meetingDateTime)), 1),
              _hoisted_45,
              _hoisted_46,
              _createVNode("div", _hoisted_47, [
                (_ctx.currentCommittee.meeting.note)
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      class: "ql-editor",
                      innerHTML: _ctx.currentCommittee.meeting.note
                    }, null, 8, ["innerHTML"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.showFileDeleteAlertBox)
      ? (_openBlock(), _createBlock(_component_AlertBox, {
          key: 0,
          onClose: _cache[11] || (_cache[11] = $event => (_ctx.showFileDeleteAlertBox = false))
        }, {
          header: _withId(() => [
            _hoisted_48
          ]),
          body: _withId(() => [
            _hoisted_49
          ]),
          footer: _withId(() => [
            _createVNode("button", {
              class: "btn btn-secondary sml",
              onClick: _cache[9] || (_cache[9] = $event => (_ctx.deletePersonalFile()))
            }, "Yes"),
            _createVNode("button", {
              class: "btn btn-tertiary sml",
              onClick: _cache[10] || (_cache[10] = $event => (_ctx.showFileDeleteAlertBox = false))
            }, "Cancel")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showUnsavedAlertBox)
      ? (_openBlock(), _createBlock(_component_AlertBox, {
          key: 1,
          onClose: _cache[14] || (_cache[14] = $event => (_ctx.showUnsavedAlertBox = false))
        }, {
          header: _withId(() => [
            _hoisted_50
          ]),
          body: _withId(() => [
            _hoisted_51
          ]),
          footer: _withId(() => [
            _createVNode("button", {
              class: "btn btn-secondary sml",
              onClick: _cache[12] || (_cache[12] = $event => {_ctx.saveNoteAndExit(true); _ctx.showUnsavedAlertBox = false})
            }, "Save notes"),
            _createVNode("button", {
              class: "btn btn-tertiary sml",
              onClick: _cache[13] || (_cache[13] = $event => {_ctx.saveNoteAndExit(false); _ctx.showUnsavedAlertBox = false})
            }, "Back home without saving")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showHelpScreen)
      ? (_openBlock(), _createBlock(_component_HelpScreen, {
          key: 2,
          onClose: _cache[15] || (_cache[15] = $event => (_ctx.showHelpScreen = false))
        }, {
          header: _withId(() => [
            _createVNode("h3", _hoisted_52, _toDisplayString(_ctx.pageHeader), 1)
          ]),
          body: _withId(() => [
            _createVNode("p", null, _toDisplayString(_ctx.pageDescription), 1),
            _hoisted_53,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pageSection, (s, index) => {
              return (_openBlock(), _createBlock("div", null, [
                _createVNode("h4", null, _toDisplayString(s.sectionHeading), 1),
                _createVNode("p", null, _toDisplayString(s.sectionContent), 1),
                _hoisted_54
              ]))
            }), 256))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showFullScreenFileViewer)
      ? (_openBlock(), _createBlock(_component_FullScreenFileViewer, {
          key: 3,
          onClose: _cache[16] || (_cache[16] = $event => (_ctx.showFullScreenFileViewer = false))
        }, {
          header: _withId(() => [
            _createVNode("h4", null, _toDisplayString(_ctx.currentFile.name), 1)
          ]),
          body: _withId(() => [
            _createVNode("iframe", {
              id: "refDocViewer",
              ref: "refDocViewer",
              style: {"width":"99%","height":"100vh"},
              class: "vue-doc-viewer",
              src: _ctx.fileSource,
              title: "iframe"
            }, "\n      ", 8, ["src"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
})